// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__Dr_M1","content":"index_content__OE1x1"};